<script lang="ts">
  import type {
    FieldGoalEvent,
    GameraTeamReference,
  } from '@statmuse/core/gamera'

  export let team: GameraTeamReference | undefined
  export let fieldGoals: FieldGoalEvent[]
  export let domain: 'NBA' | 'WNBA' = 'NBA'

  const mapXCoordinate = (x: number) => -1 * x * (130.05 / 250) + 130.05
  const mapYCoordinate = (y: number) => -1 * y * (214.5 / 430) + 214.5

  $: shots = fieldGoals
    .filter(
      (p): p is FieldGoalEvent =>
        p.type === 'fieldGoal' && team?.teamId === p.teamId,
    )
    .map((p) => ({ ...p.coordinates, isMade: p.isMade }))
</script>

<svg
  {...$$restProps}
  version="1.1"
  xmlns="http://www.w3.org/2000/svg"
  xmlns:xlink="http://www.w3.org/1999/xlink"
  viewBox="0 0 260.1 243.4"
>
  <g
    style="fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;"
  >
    {#if domain === 'NBA'}
      <path
        d="m242.8 243.4v-74.8c-18.4-44.1-62-75.2-112.8-75.2s-94.3 31.1-112.7 75.2v74.8"
      />
    {:else}
      <path
        d="m241 243.4v-65.9c-18.1-43.4-61-74-111-74s-92.8 30.6-110.9 74v65.9"
      />
    {/if}

    <path d="m90.1 243.1v-98.7h80.2v98.7" />
    <path
      d="m100.1 144.4h60.2c0-16.6-13.5-30.1-30.1-30.1s-30.1 13.5-30.1 30.1z"
    />
    <path d="m160.2 146.9c0-.8.1-1.7.1-2.5h-2.5" />
    <path d="m152.8 144.4h-47.7" stroke-dasharray="5 5" />
    <path d="m102.6 144.4h-2.5v2.5" />
    <path
      d="m101.1 152c3.4 12.9 15.1 22.4 29.1 22.4s27.2-10.8 29.7-25"
      stroke-dasharray="5.3 5.3"
    />
    <path
      d="m150.9 220.3v-13.7c-3.4-8.1-11.4-13.8-20.7-13.8s-17.3 5.7-20.7 13.8v13.7"
    />
    <path d="m115.5 221.3h29.3" />
    <circle cx="130.2" cy="214.6" r="4" />
  </g>
  {#each shots as shot (shot)}
    <circle
      fill={shot.isMade ? team?.colors?.backgroundColor : 'none'}
      stroke={team?.colors?.backgroundColor}
      stroke-width="1"
      r="4"
      cx={mapXCoordinate(shot.x)}
      cy={mapYCoordinate(shot.y)}
    />
  {/each}
</svg>
